import { services } from '../../data/services';
import { SectionLabel } from '../ui/SectionLabel';

export function Services() {
  return (
    <section className="section section-alt" id="services" aria-labelledby="services-title">
      <div className="wrap">
        <div className="section-head" data-reveal>
          <SectionLabel>Capabilities</SectionLabel>
          <h2 id="services-title">Integrated engineering across the system lifecycle.</h2>
        </div>

        <ol className="services">
          {services.map((service, index) => (
            <li
              className="service"
              key={service.number}
              data-reveal
              style={{ '--reveal-index': index } as React.CSSProperties}
            >
              <span className="service-num" aria-hidden="true">
                {service.number}
              </span>
              <div className="service-body">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-desc">{service.description}</p>
                <p className="service-tech">{service.capabilities.join(' · ')}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
